import React from 'react'
import DashboardCard from './DashboardCard'

import {
  AccountBalanceWalletOutlined,
  Send,
  Schedule,
  Person,
} from '@material-ui/icons'

const styles = {
  iconStyle: {
    fontSize: 40
    // border: '1px solid white'
  },
  icon: {
    width: 64,
    height: 64,
  }
}

const DashboardCards = ({
  balance = 0,
  activeCampaigns = 0,
  completedCampaigns = 0,
  totalUsers = 0,
}) => {
  const cards = [
    {
      title: 'POINT BALANCE',
      subtitle: balance,
      icon: <img src="icons/Point-Balance150.png" alt="point_balance_icon" style={styles.icon} />
    },
    {
      title: 'ACTIVE CAMPAIGNS',
      subtitle: activeCampaigns,
      icon: <img src="icons/Active-Campaigns150.png" alt="active_campaigns_icon" style={styles.icon} />
    },
    {
      title: 'COMPLETED CAMPAIGNS',
      subtitle: completedCampaigns,
      icon: <img src="icons/Completed-Campaigns150.png" alt="completed_campaigns_icon" style={styles.icon} />
    },
    {
      title: 'TOTAL MEMBERS',
      subtitle: totalUsers,
      icon: <img src="icons/Total-Members150.png" alt="point_balance_icon" style={styles.icon} />
    }
  ];
  return cards.map((card, i) => {
    return (
      <DashboardCard
        title={card.title}
        subtitle={card.subtitle}
        icon={card.icon}
        key={i}
      />
    )
  })
}

export default DashboardCards
